/*
Copyright© Celligence International, LLC - 2024
This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { LDCProvider } from '../contexts/LoanDefaultCodesContext';
import { memo } from 'react';
import LoanInformationForm from '../components/forms/LoanInformationForm';
import { LoanInformationProvider } from '../contexts/LoanInformationContext';
import { SnackbarProvider } from 'notistack';

const LoginPage = () => {
  return (
    <SnackbarProvider
      hideIconVariant
      maxSnack={3}
      preventDuplicate
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <LDCProvider>
        <LoanInformationProvider>
          <LoanInformationForm />
        </LoanInformationProvider>
      </LDCProvider>
    </SnackbarProvider>
  );
};

export default memo(LoginPage);
